import * as tslib_1 from "tslib";
import { Component } from '@angular/core';
import { FieldType } from '../../../core';
var FormlyFieldTextArea = (function (_super) {
    tslib_1.__extends(FormlyFieldTextArea, _super);
    function FormlyFieldTextArea() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return FormlyFieldTextArea;
}(FieldType));
FormlyFieldTextArea = tslib_1.__decorate([
    Component({
        selector: 'formly-field-textarea',
        template: "\n    <textarea [name]=\"key\" [formControl]=\"formControl\" [cols]=\"to.cols\"\n      [rows]=\"to.rows\" class=\"form-control\"\n      [formlyAttributes]=\"field\">\n    </textarea>\n  ",
    })
], FormlyFieldTextArea);
export { FormlyFieldTextArea };
//# sourceMappingURL=textarea.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-formly/lib/src/ui-bootstrap/src/types/textarea.js
// module id = 777
// module chunks = 3